<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} mensaje
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  name="Titulo"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.title"
                    placeholder="Título"
                    :error-messages="errors"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="Mensaje" rules="required|max:1024" v-slot="{ errors }">
                  <v-textarea
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    name="message"
                    label="Mensaje"
                    v-model="payload.message"
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      clientList: [],
      queueList: [],
      payload: {
        message: "",
      },
    };
  },

  created() {
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.message = "";
      // this.payload.client_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async submitForm() {
      this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      // const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/whatsapps/preset-messages/${id}`, payload)
          : await PbxHttpClient.post("/whatsapps/preset-messages/", payload);
        this.closeDialog(data);

        this.$snotify.success(
          `Mensaje ${this.isEditMode ? "actualizado" : "creado"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
